// Ensures a user-entered value is a real web link, not a code snippet / markup / dangerous
// pseudo-URL. Used by the link-button and social-link modals before anything is saved.

export const INVALID_URL_WARNING =
    'Please enter a valid link (e.g. https://example.com).'

const DANGEROUS_SCHEME = /^\s*(javascript|data|vbscript|file|blob):/i

/**
 * True if `raw` is a genuine http(s) URL pointing at a real domain. A scheme-less value
 * (e.g. "example.com/path") is accepted and treated as https. Code, markup and dangerous
 * schemes (javascript:, data:, …) are rejected.
 */
export function isValidLinkUrl(raw) {
    const value = (raw || '').trim()
    if (!value) return false
    if (DANGEROUS_SCHEME.test(value)) return false   // javascript:, data:, …
    if (/[<>]/.test(value)) return false             // markup / code

    let url
    try {
        const withScheme = /^https?:\/\//i.test(value) ? value : `https://${value}`
        url = new URL(withScheme)                     // throws on spaces / `<>` / junk in the authority
    } catch {
        return false
    }

    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
    // Host must be a real domain: one+ labels + a 2+ letter TLD (rejects "alert(1)", bare words, IPs).
    return /^([a-z0-9-]+\.)+[a-z]{2,}$/i.test(url.hostname)
}
